import { Injectable } from '@angular/core';
import { PayPalEcStatesEnum } from 'i2g-ng-payment';

@Injectable()
export class PaymentsDataStateService {
  /**
   * Check if account is pending PayPal underwriting
   *
   * @param status Account PayPal status
   */
  isPayPalUnderwritingRequired(status: PayPalEcStatesEnum) {
    return [
      PayPalEcStatesEnum.in_progress,
      PayPalEcStatesEnum.underwriting_required,
      PayPalEcStatesEnum.unlinked,
    ].includes(status);
  }
}
